// export const MAIN_STUDIO = 'supergroup';
export const MAIN_STUDIO = 'main-studio';
